export class SetUserPasswordUsingPinDto {
    readonly email: string;

    readonly password: string;

    readonly pin: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawDetails: any) {
        this.email = rawDetails.email;
        this.password = rawDetails.password;
        this.pin = rawDetails.pin;
    }
}
